export default class Chat {
  constructor(Vue) {
    this.utils = Vue.prototype.$utils;
    this.company = Vue.prototype.$company;
    this.cookies = Vue.prototype.$cookies;
  }

  open(type) {
    const token = _.get(this.company.json, 'chat.token');

    if (!token) {
      console.warn('No chat token found');
      return;
    }

    this.close(type);

    const functions = {
      zendesk: 'openZendesk',
      tawk: 'openTawk',
      blip: 'openBlip',
      zenvia: 'openZenvia',
      tiflux: 'openTiflux',
    };

    if (type && functions[type]) {
      try {
        return this[functions[type]]();
      } catch (error) {
        console.error(`Error opening chat for type: ${type}`, error);
      }
    } else {
      console.warn(`No open function found for type: ${type}`);
    }
  }

  close(type) {
    const functions = {
      zendesk: 'closeZendesk',
      tawk: 'closeTawk',
      blip: 'closeBlip',
      zenvia: 'closeZenvia',
      tiflux: 'closeTiflux',
    };

    if (type && functions[type]) {
      try {
        return this[functions[type]]();
      } catch (error) {
        console.error(`Error closing chat for type: ${type}`, error);
      }
    } else {
      console.warn(`No close function found for type: ${type}`);
    }
  }

  openBlip() {
    const s1 = document.createElement('script');
    s1.async = false;
    s1.src = 'https://unpkg.com/blip-chat-widget';
    s1.charset = 'UTF-8';
    const s0 = document.getElementsByTagName('body')[0].getElementsByTagName('script')[0];
    s0.parentNode.insertBefore(s1, s0);
    const s2 = document.createElement('script');
    s2.charset = 'UTF-8';
    s2.text = `
    var chat = new BlipChat()
          .withAppKey('${_.get(this.company.json, 'chat.token')}')
          .withButton({"color": "${this.company.json.style.color.primary}","icon":""})
          .build();`;
    setTimeout(() => {
      s0.parentNode.insertBefore(s2, s0);
    }, 800);
  }

  openZenvia() {
    const s1 = document.createElement('script');
    s1.async = false;
    s1.src = 'https://static.zenvia.com/embed/js/zenvia-chat.min.js';
    s1.charset = 'UTF-8';
    const s0 = document.getElementsByTagName('body')[0].getElementsByTagName('script')[0];
    s0.parentNode.insertBefore(s1, s0);
    const s2 = document.createElement('script');
    s2.text = `var chat = new ZenviaChat('${_.get(this.company.json, 'chat.token')}').embedded('button').build();`;
    setTimeout(() => {
      s0.parentNode.insertBefore(s2, s0);
    }, 800);
  }

  openTawk() {
    const Tawk_API = Tawk_API || {};
    const s1 = document.createElement('script');
    const s0 = document.getElementsByTagName('body')[0].getElementsByTagName('script')[0];
    s1.setAttribute('id', 'scriptChat');
    s1.async = true;
    s1.src = `https://embed.tawk.to/${_.get(this.company.json, 'chat.token')}/default`;
    // s1.src = `https://embed.tawk.to/5cacde7853f1e453fb8cfaab/default`;
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    s0.parentNode.insertBefore(s1, s0);
  }

  openTiflux() {
    const script = document.createElement('script');
    const organization_token = _.get(this.company.json, 'chat.token');
    window.organization_token = organization_token;
    script.src = `https://public-assets.tiflux.com/chat_widget.js?organization_token=${organization_token}`;
    document.head.appendChild(script);
  }

  openZendesk() {
    const s1 = document.createElement('script');
    const key = _.get(this.company.json, 'chat.token');
    s1.id = 'ze-snippet';
    s1.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;
    s1.async = true;
    const s0 = document.getElementsByTagName('body')[0].getElementsByTagName('script')[0];
    s0.parentNode.insertBefore(s1, s0);
  }

  closeZendesk() {
    const script = document.getElementById('ze-snippet');
    if (script)
      script.parentNode.removeChild(script);
  }

  closeTiflux() {
    window.organization_token = undefined;
  }

  closeZenvia() {
    this.cookies.remove('_zid');
  }

  closeTawk() {
    this.cookies.remove('TawkConnectionTime');
    this.cookies.remove('__tawkuuid');
  }

  closeBlip() {
    window.localStorage.removeItem('blipSdkUAccount');
  }
}
